var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadAssignmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3709_2310",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3373 1.6709H1.67157V18.3367H18.3373V1.6709Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3767 7.04531C16.7992 7.94809 17.0359 8.95458 17.0359 10.0154C17.0359 13.8923 13.8818 17.0463 10.005 17.0463C6.12816 17.0463 2.97413 13.8923 2.97413 10.0154C2.97413 6.13862 6.12816 2.98456 10.005 2.98456C10.5173 2.98456 11.0169 3.04016 11.4983 3.14471L12.5622 2.08084C11.7466 1.81897 10.8863 1.67116 10.005 1.67116C7.77921 1.67116 5.68665 2.54933 4.11274 4.1232C2.5389 5.69708 1.67212 7.78964 1.67212 10.0154C1.67212 12.2412 2.5389 14.3338 4.11274 15.9077C5.68665 17.4815 7.77921 18.3369 10.005 18.3369C12.2308 18.3369 14.3233 17.4815 15.8973 15.9077C17.4711 14.3338 18.3379 12.2412 18.3379 10.0154C18.3379 8.61642 17.9952 7.2701 17.3499 6.07209L16.3767 7.04531Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3709_2310)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3709_2310",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.67377 1.67018H18.3395V18.3359H1.67377V1.67018Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3709_2310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.42291 8.48159C7.42291 7.05513 8.57929 5.89872 10.0058 5.89872C11.4322 5.89872 12.5886 7.05513 12.5886 8.48159C12.5886 9.90804 11.4322 11.0645 10.0058 11.0645C8.57929 11.0645 7.42291 9.90804 7.42291 8.48159Z",
    stroke: "white",
    strokeWidth: 1.56241,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24219 15.8291C5.24219 13.199 7.37426 11.067 10.0043 11.067C12.6344 11.067 14.7665 13.199 14.7665 15.8291",
    stroke: "white",
    strokeWidth: 1.56241,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4275 3.23289L14.7258 5.93457L13.0983 4.30706",
    stroke: "white",
    strokeWidth: 1.56241,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3784 7.04336C16.8009 7.94614 17.0375 8.95263 17.0375 10.0135C17.0375 13.8903 13.8835 17.0443 10.0066 17.0443C6.12981 17.0443 2.97578 13.8903 2.97578 10.0135C2.97578 6.13667 6.12981 2.98261 10.0066 2.98261C10.519 2.98261 11.0185 3.03821 11.5 3.14276L12.5639 2.07888C11.7482 1.81701 10.888 1.6692 10.0066 1.6692C7.78086 1.6692 5.68829 2.54738 4.11439 4.12125C2.54055 5.69512 1.67377 7.78769 1.67377 10.0135C1.67377 12.2393 2.54055 14.3318 4.11439 15.9057C5.68829 17.4796 7.78086 18.335 10.0066 18.335C12.2324 18.335 14.325 17.4796 15.8989 15.9057C17.4727 14.3318 18.3395 12.2393 18.3395 10.0135C18.3395 8.61446 17.9969 7.26815 17.3516 6.07014L16.3784 7.04336Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadAssignmentIcon);
export default __webpack_public_path__ + "static/media/lead-assignment-icon.414611572134cca4551a26588e63ae81.svg";
export { ForwardRef as ReactComponent };